import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'

const tokenState = createPersistedState( {
  key: 'token',
  paths: [ 'auth.token' ],
} );

export default createStore( {

  state: {
    transPanelMenu: 0
  },
  mutations: {
    TRANS_PANEL( state, val ) {
      state.transPanelMenu = val
    }
  },
  actions: {
    transPanel( { commit }, val ) {
      commit( 'TRANS_PANEL', val )
    }
  },
  getters: {
    getTransPanel( state ) {
      return state.transPanelMenu
    }
  },
  modules: {
    auth
  },
  plugins: [ tokenState ]
} )